export default __webpack_public_path__ + "static/media/Empathy.c88bc638.svg";